import {GetWalletResponse_Tab} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.types';
import {GenericIconName, IconName} from '@aboutyou/ui-components';
import {useMemo} from 'react';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useIsCoinsActive} from '../../../features/Coins/utils/useIsCoinsActive';
import {useIsCouponWalletActive} from '../../../features/Coupons/CouponWallet/hooks/useIsCouponWalletActive';
import {WalletType} from './useActiveTab';

export interface NormalizedWalletTab extends GetWalletResponse_Tab {
  value: WalletType;
  icon: IconName;
}

export const useNormalizeTabs = (tabs: GetWalletResponse_Tab[]) => {
  const {isAuthenticated} = useIsAuthenticated();
  const isCoinsActive = useIsCoinsActive();
  const isCouponWalletActive = useIsCouponWalletActive();

  return useMemo(
    () =>
      tabs.reduce((walletTabs, tab) => {
        if (
          (tab.type?.$case === 'coins' || tab.type?.$case === 'coinsError') &&
          isCoinsActive &&
          isAuthenticated
        ) {
          walletTabs.push({
            value: 'coins',
            icon: GenericIconName.Coins,
            ...tab,
          });
        }

        if (
          (tab.type?.$case === 'coupons' ||
            tab.type?.$case === 'couponsError') &&
          isCouponWalletActive
        ) {
          walletTabs.push({
            value: 'coupons',
            icon: GenericIconName.Coupons,
            ...tab,
          });
        }

        if (
          tab.type?.$case === 'notificationCenter' ||
          tab.type?.$case === 'notificationCenterError'
        ) {
          walletTabs.push({
            value: 'notificationCenter',
            icon: GenericIconName.Bell,
            ...tab,
          });
        }

        return walletTabs;
      }, [] as NormalizedWalletTab[]),
    [isAuthenticated, isCoinsActive, isCouponWalletActive, tabs],
  );
};
